import { Input } from '../ui/input';
import { Label } from '../ui/label';

type Props = {
  appName: string;
  onNameChange: (name: string) => void;
};

export default function ManagementNameSettings({ appName, onNameChange }: Props) {
  return (
    <section aria-labelledby="management-name-heading" className="mb-0 min-w-0">
      <h2
        id="management-name-heading"
        className="mb-2 text-xs font-semibold uppercase tracking-wide text-app-text-muted"
      >
        App name
      </h2>
      <p className="mb-2 text-sm text-app-text-secondary">
        Used in the published app URL. Changing it may update the URL; the display name is separate.
      </p>
      <Label htmlFor="fabrik-canonical-app-name" className="sr-only">
        App name
      </Label>
      <Input
        id="fabrik-canonical-app-name"
        aria-label="App name"
        value={appName}
        maxLength={80}
        onChange={(event) => onNameChange(event.target.value)}
        className="h-9 w-full"
      />
    </section>
  );
}
